// ============================================================================
// BUCKET CONFIGURATION SYSTEM
// ============================================================================
//
// Provides configurable bucket presets for deal size distribution charts
// Allows switching between different deal size groupings
//

export interface BucketRange {
  label: string;
  minAmount: number;
  maxAmount: number;
}

export interface BucketPreset {
  id: string;
  name: string;
  description: string;
  buckets: BucketRange[];
}

// Predefined bucket presets
export const BUCKET_PRESETS: Record<string, BucketPreset> = {
  default: {
    id: "default",
    name: "Default ($0-500, $500-2k, $2-5k, $5-10k, $10k+)",
    description: "Standard deal size distribution",
    buckets: [
      { label: "$0-500", minAmount: 0, maxAmount: 500 },
      { label: "$500-2k", minAmount: 500, maxAmount: 2000 },
      { label: "$2-5k", minAmount: 2000, maxAmount: 5000 },
      { label: "$5-10k", minAmount: 5000, maxAmount: 10000 },
      { label: "$10k+", minAmount: 10000, maxAmount: Infinity },
    ],
  },
  enterprise: {
    id: "enterprise",
    name: "Enterprise (<$50k, $50-100k, $100-250k, $250k+)",
    description: "Large deal distribution",
    buckets: [
      { label: "<$50k", minAmount: 0, maxAmount: 50000 },
      { label: "$50-100k", minAmount: 50000, maxAmount: 100000 },
      { label: "$100-250k", minAmount: 100000, maxAmount: 250000 },
      { label: "$250k+", minAmount: 250000, maxAmount: Infinity },
    ],
  },
};

// Get default preset
export function getDefaultBucketPreset(): BucketPreset {
  return BUCKET_PRESETS.default;
}

// Get preset by ID
export function getBucketPreset(presetId: string): BucketPreset {
  return BUCKET_PRESETS[presetId] || getDefaultBucketPreset();
}

// Format bucket label with currency
export function formatBucketLabel(range: BucketRange): string {
  return range.label;
}
